import { ApiEnv } from 'src/clients/Network/http/fetch';

export const LoginPageUrl =
  ApiEnv === 'production'
    ? 'https://robinhood.com/login?to=/creditcard/application'
    : 'https://webapp--x1-apollo.apollo.rhinternal.net/login?to=/creditcard/application';
